export const PROFILE_NAV = ['Me', 'Ich', 'Ben'];
